import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProductAnalysisItemDTO  {
    _originalTypeClassName = "zPMO.BO.ProductAnalysisItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProductAnalysisItemDTO.translate = translateService;
}
this.ClientId = null;
this.ClientName = null;
this.ProjectName = null;
this.ProjectId = null;
this.Budget = null;
this.Date = null;
this.Licences = null;
this.Period = null;
this.ProductAnalysisItemDTOKey = null;
this._key = this.ProductAnalysisItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
ClientId:any;
ClientName:any;
ProjectName:any;
ProjectId:any;
Budget:any;
Date:any;
Licences:any;
Period:any;
private _ProductAnalysisItemDTOKey:any;
get ProductAnalysisItemDTOKey(): any {
    return this._ProductAnalysisItemDTOKey;
  }
set ProductAnalysisItemDTOKey(value: any) {
    this._ProductAnalysisItemDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ProductAnalysisItemDTOKey == null || $this.ProductAnalysisItemDTOKey == 0;
            }


}